
import state from './commonsState.js'
import * as mutations from './commonsMutations.js'
import * as actions from './commonsActions.js'
import * as getters from './commonsGetters.js'

export default {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}